import React, { useState } from 'react';
import { PolicyContentView } from './components/policy-content-view';
import { POLICY_CONTENT } from './policy-config';

export default function Legal() {
  const [activeContent, setActiveContent] = useState(POLICY_CONTENT.COOKIES);
  return (
    <PolicyContentView
      setPolicyPageActive={true}
      activeContent={activeContent}
      setActiveContent={setActiveContent}
      showReturnToLoginLink={false}
    />
  );
}
